module.exports = __webpack_public_path__ + "static/img/setup-end.976252d1.png";